import React, { useEffect, useState } from 'react'
import '../../assets/css/ManageBrand.css'
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';



function ManageBrand({ darkMode }) {
    console.log("Dark Mode in ManageBrand:", darkMode);
    const [brandName, setBrandName] = useState("");
    // const [logo, setLogo] = useState(null);
    const [image, setImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [brands, setBrands] = useState([])
    const [brandId, setBrandId] = useState(null);
    // const [logoPreview, setLogoPreview] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;
    const baseUrl = "https://devapi.bykit.in/storage/brands/";


    const handleAddOrUpdateBrand = async (e) => {
        e.preventDefault();
        setSubmitted(true);

        if (!brandId) {
            if (!brandName.trim()) return;
            if (!image) return toast.error("Please Select image");
        }

        const formData = new FormData();
        formData.append("name", brandName);
        formData.append("logo", new Blob([""], { type: "text/plain" }));
        formData.append("image", image);

        if (brandId) {
            formData.append("id", brandId);
        }
        console.log('formdataaa', formData)
        try {
            let response;
            if (brandId) {
                formData.append("id", brandId);
                console.log("Updating brand with ID:", brandId);
                response = await axios.post(`https://devapi.bykit.in/api/admin/brands/update??type=live`, formData, {
                    headers: {
                        //Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });

                console.log("updated:", response);
                toast.success("Brand updated successfully!");

            } else {
                response = await axios.post("https://devapi.bykit.in/api/admin/brands/add??type=live", formData, {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`
                    }
                });
                console.log("updated:", response);
                toast.success("Brand added successfully!");
            }

            setIsModalOpen(false);

            getAdminData();
        } catch (error) {
            console.error("Error adding/updating brand:", error);
            toast.error("An error occurred.");
        }
    };

    const handleEditClick = (brand) => {
        console.log("Editing brand:", brand);
        setBrandId(brand.id);
        setBrandName(brand.name);
        setIsModalOpen(true);

        // Only set preview if a valid image exists
        // setLogoPreview(brand.logo ? (brand.logo.startsWith("http") ? brand.logo : `${baseUrl}${brand.logo}`) : "");
        setImagePreview(brand.image ? (brand.image.startsWith("http") ? brand.image : `${baseUrl}${brand.image}`) : "");
    };


    const handleAddNewClick = () => {
        setBrandId("");
        setBrandName("");
        // setLogo(null); 
        setImage(null);
        // setLogoPreview(""); 
        setImagePreview("");
        setSubmitted(false);
        setIsModalOpen(true);
    };


    // const handleLogoChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setLogo(file);
    //         setLogoPreview(URL.createObjectURL(file));
    //     }
    // };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("Selected File:", file);

        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };


    const getAdminData = async () => {

        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token
        // const token = localStorage.getItem("token");
        console.log("Token: ?????", token);

        try {
            const response = await axios.get(
                'https://devapi.bykit.in/api/admin/brands?page=1&search=&?type=live',
                {
                    method: 'post',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });

            console.log("API Response:", response);

            if (response.data.status === "RC200") {
                setBrands(response.data.data);
            } else {
                alert('Invalid credentials, please try again.');
            }
        } catch (error) {
            console.error('Error during login:', error);
        }
    };


    useEffect(() => {
        getAdminData();
    }, []);

    const filteredBrands = brands.filter(brand =>
        brand.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowModal(true);
    };

    const confirmDelete = async () => {
        if (!deleteId) return;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/brands/delete/${deleteId}??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Brand deleted successfully", { position: "top-right" });
                setBrands((prevBrands) => prevBrands.filter((brand) => brand.id !== deleteId));
            } else {
                toast.error("Failed to delete the brand.", { position: "top-right" });
            }
        } catch (error) {
            console.error("Error deleting brand:", error);
            toast.error("An error occurred while deleting the brand.", { position: "top-right" });
        }

        setShowModal(false);
        setDeleteId(null);
    };


    return (
        <div className='p-3'>
            <ToastContainer></ToastContainer>
            <div className="d-flex align-items-center gap-3">
                <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Manage Brand</p>
            </div>

            <div className={`managebrand_box mt-3 mb-2 py-4 d-flex justify-content-between ${darkMode ? "dark-mode" : ""}`}>
                <h4 className='dashboard_head ps-3'>Manage Brand</h4>
                <div className=''>
                    <input type='text' className='manage_brand_search me-2' placeholder='search' value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}></input>
                    <button className='add_brand_btn me-3' onClick={handleAddNewClick}>+ Add Brand</button>
                </div>
            </div>

            <div className="card-list">

                {filteredBrands && filteredBrands.map((item) => (
                    <div className="card" key={item.id}>
                        <div className="card-left">
                            <img src={item.image} alt="" className="image-large" />
                            <div className='mobile_ms'>
                                <div className='d-flex'>
                                    {/* <img src={`${baseUrl}${item.logo}`} alt="" className="image-small" /> */}
                                    <h3 className='brand_name pt-1 ps-2 d-block'>{item.name}</h3>
                                </div>
                                <p className='created_date'>Created at: {item.date}</p>
                            </div>
                        </div>

                        <div className="card-right">
                            <button className="edit-btn" onClick={() => handleEditClick(item)}>
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--heroicons me-1" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path></svg>
                                Edit</button>
                            <button className="delete-btn" onClick={() => handleDeleteClick(item.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--heroicons me-1" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.088 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0"></path></svg>
                                Delete</button>
                        </div>
                    </div>
                ))}
            </div>

            {isModalOpen && (
                <div className="modal fade show" style={{ display: "block" }} id="addBrandModal" tabIndex="-1" aria-labelledby="addBrandModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal_width">
                        <div className="modal-content">
                            <div className="modal-header bg-dark text-white">
                                <h5 className="modal-title">{brandId ? "Edit" : "Add"} Brand</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setIsModalOpen(false)}></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleAddOrUpdateBrand}>
                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className={`form-control ${submitted && !brandName.trim() ? "is-invalid" : ""}`}
                                            placeholder="Enter brand name"
                                            value={brandName}
                                            onChange={(e) => setBrandName(e.target.value)}
                                        />
                                        {submitted && !brandName.trim() && <div className="invalid-feedback">Name is Required</div>}
                                    </div>

                                    <div className="mb-3 d-flex gap-3">
                                        {/* <div>
                                            <label className="form-label">Logo</label>
                                            <input type="file" className="form-control" onChange={handleLogoChange} accept="image/*" />
                                            {logoPreview && <img src={logoPreview} alt="Logo Preview" className="preview-image" />}
                                        </div> */}
                                        <div>
                                            <label className="form-label">Image</label>
                                            <input type="file" className="form-control" onChange={handleImageChange} accept="image/*" />
                                            {imagePreview && <img src={imagePreview} alt="Image Preview" className="preview-image" />}
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end">
                                        <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--ic" width="1em" height="1em" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2-2h6c1.1 0 2 .9 2 2s-.9 2-2 2"></path>
                                            </svg>
                                            <span>{brandId ? "Update" : "Submit"}</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay delete-overlay">
                    <div className="modal-content delete-content">
                        <div className="modal-header bg-dark text-white mt-0">
                            <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className='p-3'>
                            <p className='delete_text'>Are you sure, do you want to delete?</p>
                        </div>
                        <hr className='p-0 m-0'></hr>
                        <div className="modal-buttons text-end p-3">
                            <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
                            <button onClick={confirmDelete} className='model_dlt_btn'>Yes</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ManageBrand